import { RESOURCE_TYPE_FILE, RESOURCE_TYPE_MERGED_FILE } from "@Features/transmittals/hooks/transmittal.types";

/**
 * Expands a viewer's `fileVersionId` into the list of fileVersionIds whose
 * model-properties we actually want to load.
 *
 *   RESOURCE_TYPE_FILE         → [fileVersionId]
 *   RESOURCE_TYPE_MERGED_FILE  → non-deleted sourceFileVersionId[].id
 *
 * Same branching the viewer uses when dispatching the initial
 * `getModelProperties`.
 */
export function resolveFileVersionIds(filesData: Record<string, any> | undefined, fileVersionId: string): string[] {
  if (!fileVersionId) return [];
  const entry = filesData?.[fileVersionId];
  if (!entry) return [fileVersionId];

  if (entry.resourceType === RESOURCE_TYPE_FILE) {
    return [fileVersionId];
  }
  if (entry.resourceType === RESOURCE_TYPE_MERGED_FILE) {
    return (entry.sourceFileVersionId ?? [])
      .filter((sf: { id: string; isDeleted?: boolean }) => !sf.isDeleted)
      .map((sf: { id: string }) => sf.id);
  }
  return [fileVersionId];
}
